export default __webpack_public_path__ + "assets/images/97de8ea22e267738406949161ad31acd.svg";